import api from "../configuration/ApiConfig";
const customerServices = {
  /* RegisterCustomer:(customer)=>{
    const request = api.post('Customers/RegisterCustomer',customer)
    return request.then((response)=>{
        return response.data
    })
}, */
  RegisterCustomer: (customer, PDF) => {
    const headers = {
      "Content-Type": "multipart/form-data",
    };
    let formData = new FormData();
    const pdfFile = new Blob([PDF], { type: "application/pdf" });
    formData.append("file", pdfFile);
    formData.append("amount", customer.amount);
    formData.append("paymentMethod", customer.paymentMethod);
    formData.append("paymentToken", customer.paymentToken);
    formData.append("customerId", customer.customerId);
    formData.append("customerFirstName", customer.customerFirstName);
    formData.append("customerLastName", customer.customerLastName);
    formData.append("businessName", customer.businessName);
    formData.append("email", customer.email);
    formData.append("addressLine1", customer.addressLine1);
    formData.append("addressLine2", customer.addressLine2);
    formData.append("city", customer.city);
    formData.append("state", customer.state);
    formData.append("zipCode", customer.zipCode);
    formData.append("signature", customer.signature.split(",")[1]);
    formData.append("signFirstName", customer.signFirstName);
    formData.append("signLastName", customer.signLastName);
    formData.append("password", customer.password);
    const request = api.post("Customers/AddCustomerDetails", formData, {
      headers,
    });
    return request.then((response) => {
      return response.data;
    });
  },
  UpdateCustomer: (customer) => {
    const request = api.put("Customers/UpdateCustomer", customer);
    return request.then((response) => {
      return response.data;
    });
  },
  Register: (customer) => {
    debugger;
    const request = api.post("AbandonedCartReport/RegisterCustomer", customer);
    return request.then((response) => {
      return response.data;
    });
  },
  AddCustomerPaymentDetail: (customerPaymentDetail) => {
    const request = api.post(
      "Customers/AddCustomerPaymentDetail",
      customerPaymentDetail
    );
    return request.then((response) => {
      return response.data;
    });
  },
  LoginCustomer: (customerCredentials) => {
    const request = api.post("Auth/Login", customerCredentials);
    return request.then((response) => {
      localStorage.setItem("userName", response.data.resultData.userName);
      return response.data;
    });
  },
  LoginCustomerForAddingNewBusiness: (customerCredentials) => {
    const request = api.post(
      "Auth/LoginForAddingNewBusiness",
      customerCredentials
    );
    return request.then((response) => {
      return response.data;
    });
  },
  GetCustomerPaymentStatus: (customerCredentials) => {
    const request = api.post(
      "Customers/GetCustomerPaymentStatus",
      customerCredentials
    );
    return request.then((response) => {
      return response.data;
    });
  },
  ForgetPassword: (email) => {
    const request = api.post("Auth/ForgotPassword?email=" + email);
    return request.then((response) => {
      return response.data;
    });
  },
  ResetPassword: (resetPassword) => {
    const request = api.put("Auth/ResetPassword", resetPassword);
    return request.then((response) => {
      return response.data;
    });
  },
  GetCustomerServiceList: () => {
    const request = api.get("CustomerServices/GetCustomerServiceByCustomerId");
    return request.then((response) => {
      return response.data;
    });
  },
  GetCustomerPaymentHistory: () => {
    const request = api.get("Customers/GetCustomerPaymentHistory");
    return request.then((response) => {
      return response.data;
    });
  },
  GetSubscriptionData:()=>{
    const request = api.get("Customers/GetSubscriptionData");
    return request.then((response) => {
      return response.data;
    });
  },
  CancelSubscription:(intentId)=>{
    const request = api.post("Customers/CancelSubscription", intentId);
    return request.then((response) => {
      return response.data;
    });
  },
  SaveRegisterationAgreement: (PDF, i, j) => {
    const headers = {
      "Content-Type": "multipart/form-data",
    };
    const formData = new FormData();
    const pdfFile = new Blob([PDF], { type: "application/pdf" });
    formData.append("file", pdfFile);
    formData.append("customerBusinessId", i);
    formData.append("customerServiceId", j);
    const request = api.post("Customers/SaveRegistrationAgreement", formData, {
      headers,
    });
    return request.then((response) => {
      return response.data;
    });
  },
  GetCustomerAgreements: () => {
    const request = api.get("Customers/GetCustomerAgreements");
    return request.then((response) => {
      return response.data;
    });
  },
  DownloadCustomerAgreementByPath: (filePath) => {
    const request = api.get(
      "Customers/DownloadCustomerAgreementByPath?agreementPath=" + filePath,
      {
        responseType: "blob", // Important for binary response
      }
    );
    return request.then((response) => {
      return response.data;
    });
  },
  GetCustomerById: (id) => {
    const request = api.get("Customers/GetCustomerList?id=" + id);
    return request.then((response) => {
      return response.data;
    });
  },
  CheckCustomerExist: (email) => {
    const request = api.get("Customers/CheckCustomerExist?email=" + email);
    return request.then((response) => {
      return response.data;
    });
  },
  GetCustomerLegalToolsById: () => {
    const request = api.get("Customers/GetCustomerLegalToolsById");
    return request.then((response) => {
      return response.data;
    });
  },
  GetUser: () => {
    const request = api.get("Customers/GetCustomerById");
    return request.then((response) => {
      return response.data;
    });
  },
  CheckBusinessExist: (email, businessName) => {
    const request = api.get(
      "Customers/CheckBusinessExist?email=" +
      email +
      "&businessName=" +
      businessName
    );
    return request.then((response) => {
      return response.data;
    });
  },
  changePassword: (changePassword) => {
    const request = api.put("Customers/ChangePassword", changePassword);
    return request.then((response) => {
      return response.data;
    });
  },

  UploadDocument: (file) => {
    const formData = new FormData();
    formData.append("file", file);
    const request = api.post("Customers/InsertDocumentDetails", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return request.then((response) => {
      return response.data
    })
  },

  DeleteDocument: (id) =>{
    const request = api.post('Customers/DeleteDocumentById', id)
    return request.then((response)=>{
      return response.data
    })
  },
  
  viewDocument:(id) =>{
    const request = api.post('Customers/ViewDocumentById', id)
    return request.then((response)=>{
      return response.data
    })
  },
  RequestCall:(data) =>{
    const request = api.post('Customers/RequestCall', data)
    return request.then((response)=>{
      return response.data
    })
  },
   PostEmailForNewsletter: (email) => {
    console.log("Email in service:", email);
  const request = api.post('CustomerServices/SubscribeToNewsletter',email);
  return request.then((response) => {
    return response.data;
  }).catch((error) => {
    throw new Error(`Failed to post email: ${error.message}`);
  });
},
};
export default customerServices;
